import { Integration_Auth_Names_Enum, Integration_Names_Enum } from '@main/graphql/types.generated';
import { integrationSchemaRegistry, pemPrivateKeySchema } from '@main/shared/utils';
import { z } from 'zod/v4';

import { IntegrationAuth, IntegrationConnector, IntegrationConnectorCategory } from '../../lib';

export type GcpConnectorConfig = typeof GcpConnector._.Config;

export const GcpConnector = IntegrationConnector.make({
  provider: Integration_Names_Enum.Gcp,
  logoPath: 'images/gcp-logo.svg',
  categories: [IntegrationConnectorCategory.Cloud],
  auths: IntegrationAuth.group([
    IntegrationAuth.manual({
      name: Integration_Auth_Names_Enum.ServiceAccountPrivateKey,
      configSchema: z.object({
        projectId: z.string().min(1),
        clientEmail: z.email(),
      }),
      encryptedConfigSchema: z.object({
        privateKey: pemPrivateKeySchema().register(integrationSchemaRegistry, {
          presentation: { input: 'textarea' },
        }),
      }),
    }),
  ]),
});
